export default "__VITE_ASSET__Czh52K_f__"